const ru = {
  // Login Page
  login: {
    title: 'MedRahi',
    subtitle: 'Связываем пациентов с надёжной индийской медицинской помощью',
    emailLabel: 'Электронная почта',
    emailPlaceholder: 'вы@пример.ru',
    passwordLabel: 'Пароль',
    passwordPlaceholder: '••••••••',
    signInButton: 'Войти',
    signingIn: 'Вход...',
    noAccount: 'Нет аккаунта?',
    signUp: 'Зарегистрироваться',
  },
  
  // Register Page
  register: {
    title: 'Присоединяйтесь к MedRahi',
    subtitle: 'Создайте аккаунт, чтобы начать',
    fullNameLabel: 'Полное имя',
    emailLabel: 'Электронная почта',
    passwordLabel: 'Пароль',
    roleLabel: 'Я являюсь',
    rolePatient: 'Пациент',
    roleDoctor: 'Врач',
    roleHospital: 'Больница',
    countryLabel: 'Страна',
    countryPlaceholder: 'Ваша страна',
    phoneLabel: 'Телефон (Необязательно)',
    createAccountButton: 'Создать аккаунт',
    creatingAccount: 'Создание аккаунта...',
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
  },
  
  // Navigation
  nav: {
    treatments: 'Лечение',
    doctors: 'Врачи',
    hospitals: 'Больницы',
    services: 'Услуги',
    wellness: 'Оздоровление',
    medicalVisa: 'Медицинская виза',
    signIn: 'Войти',
    getStarted: 'Начать',
    backToHome: 'На главную',
  },
  
  // Services Menu
  servicesMenu: {
    airportPickup: 'Трансфер из аэропорта',
    languageInterpreter: 'Переводчик',
    surroundingTours: 'Бесплатные экскурсии',
    nursingCare: 'Медицинский уход',
    physiotherapist: 'Физиотерапевт',
    travelAccommodation: 'Путешествие и проживание',
    videoConsultations: 'Видеоконсультации',
  },
  
  // Landing Page
  landing: {
    heroTag: 'Доверие более 10 000 международных пациентов',
    heroTitle1: 'Получите',
    heroTitle2: 'Медицинскую помощь',
    heroTitle3: 'мирового класса в Индии',
    heroSubtitle: 'Свяжитесь с лучшими врачами и больницами Индии. Получите доступную и качественную медицинскую помощь с прозрачными ценами и индивидуальным подходом.',
    ctaStart: 'Начните свой путь',
    ctaExplore: 'Исследовать портал',
    isoCertified: 'ISO сертификат',
    nabhAccredited: 'NABH аккредитация',
    jciStandards: 'Стандарты JCI',
    platformHighlights: 'Преимущества платформы',
    realTimeStats: 'Статистика в реальном времени',
    activeNow: 'Активно сейчас',
    verifiedDoctors: 'Проверенных врачей',
    partnerHospitals: 'Больниц-партнёров',
    successRate: 'Успешность',
    patientRating: 'Оценка пациентов',
    patientsTreated: 'пациентов пролечено в этом месяце',
    
    // Features Section
    whyChoose: 'Почему выбирают MedRahi',
    featuresTitle: 'Медицинское совершенство и индийское гостеприимство',
    featuresSubtitle: 'Испытайте идеальное сочетание передовых медицинских технологий и традиционного индийского тепла',
    
    features: {
      transparentPricing: {
        title: 'Прозрачные цены',
        desc: 'Сравнивайте предложения от разных больниц. Никаких скрытых расходов. Экономьте до 70% по сравнению с западными странами.',
      },
      worldClassFacilities: {
        title: 'Учреждения мирового класса',
        desc: 'Доступ к аккредитованным JCI больницам с современными технологиями и международными стандартами.',
      },
      verifiedSpecialists: {
        title: 'Проверенные специалисты',
        desc: 'Свяжитесь с сертифицированными врачами, прошедшими международную подготовку с многолетним опытом.',
      },
      securePrivate: {
        title: 'Безопасно и конфиденциально',
        desc: 'Банковский уровень шифрования для ваших медицинских записей. Защита данных соответствует HIPAA.',
      },
      endToEndSupport: {
        title: 'Полное сопровождение',
        desc: 'От помощи с визой до постлечебного ухода. Мы заботимся обо всём для вашего комфорта.',
      },
      quickResponse: {
        title: 'Быстрый ответ',
        desc: 'Получите предложения в течение 24 часов. Общение с врачами в реальном времени. Мгновенные записи.',
      },
    },
    
    // How It Works
    yourJourney: 'Ваш путь',
    howItWorksTitle: 'Простые шаги к первоклассной помощи',
    howItWorksSubtitle: 'От запроса до выздоровления мы с вами на каждом шагу',
    steps: {
      step1: { title: 'Отправить запрос', desc: 'Расскажите нам о вашем состоянии и медицинских потребностях' },
      step2: { title: 'Сравнить предложения', desc: 'Получите подробные предложения от проверенных врачей' },
      step3: { title: 'Спланировать лечение', desc: 'Выберите врача и запланируйте приёмы' },
      step4: { title: 'Получить лечение', desc: 'Получите помощь и наслаждайтесь выздоровлением в Индии' },
    },
    startJourney: 'Начните свой путь лечения',
    
    // Specializations
    popularSpecializations: 'Популярные специализации лечения',
    indiaExpertise: 'Экспертиза Индии охватывает все медицинские области',
    specializations: {
      cardiology: 'Кардиология',
      orthopedics: 'Ортопедия',
      oncology: 'Онкология',
      fertility: 'Фертильность',
      dental: 'Стоматология',
      cosmetic: 'Косметология',
    },
    
    // For Doctors & Hospitals
    forDoctors: 'Для врачей',
    forDoctorsDesc: 'Присоединяйтесь к ведущей платформе медицинского туризма Индии и связывайтесь с международными пациентами, ищущими вашу экспертизу.',
    forHospitals: 'Для больниц',
    forHospitalsDesc: 'Станьте партнёром MedRahi, чтобы привлекать международных пациентов и демонстрировать свои первоклассные учреждения.',
    registerAsDoctor: 'Зарегистрироваться как врач',
    registerAsHospital: 'Зарегистрироваться как больница',
    
    doctorBenefits: [
      'Расширьте практику глобально',
      'Проверенные запросы пациентов',
      'Прозрачная система ценообразования',
      'Специализированная команда поддержки',
      'Повысьте свою репутацию',
    ],
    hospitalBenefits: [
      'Увеличьте международный поток',
      'Продемонстрируйте инфраструктуру',
      'Эффективно управляйте врачами',
      'Аналитика в реальном времени',
      'Маркетинговая поддержка',
    ],
    
    // CTA Section
    ctaTitle: 'Готовы испытать индийскую медицину?',
    ctaSubtitle: 'Присоединяйтесь к тысячам довольных пациентов, выбравших Индию для лечения',
    getStartedNow: 'Начать сейчас',
    
    // Footer
    healthcareWithoutBorders: 'Здравоохранение без границ',
    footerDesc: 'Соединяем международных пациентов с лучшими медицинскими специалистами Индии с 2024 года.',
    quickLinks: 'Быстрые ссылки',
    contactUs: 'Связаться с нами',
    copyright: '© 2024 MedRahi. Все права защищены. Сделано с ❤️ в Индии',
    privacyPolicy: 'Политика конфиденциальности',
    termsOfService: 'Условия использования',
    cookiePolicy: 'Политика cookies',
  },
  
  // Service Pages Common
  services: {
    enquireNow: 'Запросить бесплатную консультацию',
    responseTime: 'Ответ в течение 24 часов',
    whatsIncluded: 'Что включено',
    
    enquiryForm: {
      fullName: 'Полное имя',
      email: 'Электронная почта',
      phone: 'Телефон',
      country: 'Страна',
      countryPlaceholder: 'Ваша страна проживания',
      additionalRequirements: 'Дополнительные требования',
      additionalPlaceholder: 'Расскажите нам больше о ваших потребностях...',
      cancel: 'Отмена',
      submit: 'Отправить запрос',
      successMessage: 'Запрос успешно отправлен! Наша команда свяжется с вами в течение 24 часов.',
    },
    
    airportPickup: {
      title: 'Трансфер из аэропорта',
      subtitle: 'Беспроблемные трансферы для вашего медицинского путешествия. Безопасный, надёжный и комфортный транспорт.',
      mainTitle: 'Добро пожаловать в путешествие без стресса',
      mainDesc1: 'Прибытие в новую страну для лечения может быть пугающим. Наша служба трансфера обеспечит комфортное начало и завершение вашего медицинского путешествия.',
      mainDesc2: 'Наши профессиональные водители встретят вас в аэропорту с именной табличкой, помогут с багажом и безопасно доставят в гостиницу или больницу.',
      features: {
        availability: { title: 'Доступность 24/7', desc: 'Круглосуточный сервис для ранних утренних или поздних ночных рейсов.' },
        safe: { title: 'Безопасно и надёжно', desc: 'Опытные лицензированные водители с чистыми автомобилями.' },
        doorToDoor: { title: 'Дверь в дверь', desc: 'Прямой трансфер из аэропорта в отель, больницу или любое место.' },
        flightMonitoring: { title: 'Отслеживание рейсов', desc: 'Мы следим за статусом вашего рейса для корректировки времени встречи.' },
      },
      included: [
        'Встреча в зоне прилёта с именной табличкой',
        'Помощь с багажом и навигация в аэропорту',
        'Комфортные автомобили с кондиционером',
        'Англоговорящие водители, знающие маршруты к больницам',
        'Автомобили с доступом для инвалидных колясок по запросу',
        'Бесплатная бутилированная вода',
        'Зарядка мобильных устройств в автомобиле',
        'Бесплатное ожидание при задержке рейса',
      ],
      vehicleOptions: 'Варианты автомобилей',
      sedan: { title: 'Седан', desc: 'Для 1-2 пассажиров', features: ['Комфортные сиденья', '2 больших чемодана', 'Кондиционер и музыка'] },
      suv: { title: 'Внедорожник', desc: 'Для 3-4 пассажиров', features: ['Просторный салон', '4 больших чемодана', 'Больше места для ног'] },
      minivan: { title: 'Минивэн', desc: 'Для 5-7 пассажиров', features: ['Для семьи', '6+ больших чемоданов', 'Доступ для колясок'] },
      airportsCovered: 'Основные аэропорты, которые мы обслуживаем',
    },
    
    languageInterpreter: {
      title: 'Услуги переводчика',
      subtitle: 'Преодолейте языковой барьер во время лечения с нашими профессиональными многоязычными переводчиками.',
      mainTitle: 'Чёткая коммуникация для лучшего лечения',
      mainDesc1: 'Когда речь идёт о здоровье, каждое слово важно. Наши профессиональные медицинские переводчики гарантируют, что ничего не будет потеряно при переводе.',
      mainDesc2: 'Наши переводчики — не просто языковые эксперты, они обучены медицинской терминологии и понимают контекст здравоохранения.',
      features: {
        languages: { title: 'Более 20 языков', desc: 'Арабский, русский, французский, немецкий, испанский, китайский, японский, корейский, португальский, суахили и многие другие.' },
        medical: { title: 'Эксперты медицинской терминологии', desc: 'Все переводчики обучены медицинской лексике и протоколам здравоохранения.' },
        options: { title: 'Очно и удалённо', desc: 'Выбирайте между личным сопровождением или видео/телефонным переводом.' },
        documents: { title: 'Перевод документов', desc: 'Перевод медицинских отчётов, рецептов, выписок и других важных документов.' },
      },
      servicesInclude: 'Наши услуги перевода включают',
      servicesList: [
        'Перевод врачебных консультаций',
        'Объяснение операций и процедур',
        'Инструкции по приёму лекарств и уходу',
        'Помощь при госпитализации',
        'Поддержка по страхованию и оплате',
        'Перевод медицинских отчётов',
        'Перевод рецептов',
        'Экстренная поддержка по вызову',
        'Перевод видеоконсультаций',
        'Консультации по аптекам и лекарствам',
      ],
      languagesTitle: 'Языки, которые мы поддерживаем',
      languagesList: [
        'Арабский', 'Русский', 'Французский', 'Немецкий', 'Испанский', 'Китайский', 
        'Японский', 'Корейский', 'Португальский', 'Суахили', 'Турецкий', 'Персидский',
        'Бенгальский', 'Урду', 'Индонезийский', 'Вьетнамский', 'Тайский', 'Итальянский',
        'Голландский', 'Польский'
      ],
      languagesNote: 'Не видите свой язык? Свяжитесь с нами — мы можем организовать переводчиков для большинства языков.',
    },
    
    surroundingTours: {
      title: 'Бесплатные экскурсии по окрестностям',
      subtitle: 'Получите максимум от медицинской поездки с бесплатными экскурсиями к достопримечательностям во время восстановления.',
      mainTitle: 'Исцеление через исследование',
      mainDesc1: 'Восстановление — это не только медицинское лечение, но и обновление разума и духа. Мы верим, что знакомство с богатой культурой и природной красотой Индии может стать мощной частью вашего исцеления.',
      mainDesc2: 'Интересуетесь ли вы историческими памятниками, храмами, рынками или садами — наши местные гиды познакомят вас с чудесами Индии.',
      features: {
        guides: { title: 'Опытные местные гиды', desc: 'Знающие гиды, которые делятся увлекательными историями о каждом месте.' },
        itineraries: { title: 'Маршруты с учётом здоровья', desc: 'Экскурсии с остановками для отдыха и подходящим темпом для выздоравливающих.' },
        cuisine: { title: 'Аутентичная кухня', desc: 'Попробуйте местные блюда с учётом диетических ограничений по вашему лечению.' },
        flexible: { title: 'Гибкое расписание', desc: 'Экскурсии организованы в соответствии с вашим графиком лечения.' },
      },
      popularDestinations: 'Популярные направления',
      mumbaiRegion: 'Регион Мумбаи',
      delhiRegion: 'Регион Дели',
      includedTitle: 'Что включено в экскурсию',
      includedList: [
        'Транспорт с кондиционером',
        'Профессиональный местный гид',
        'Входные билеты на достопримечательности',
        'Бутилированная вода',
        'Лёгкие закуски',
        'Доступ для инвалидных колясок при необходимости',
        'Помощь с фотографиями',
        'Экстренный медицинский контакт',
      ],
    },
    
    nursingCare: {
      title: 'Сестринский уход',
      subtitle: 'Профессиональный медицинский уход в вашем жилье для комфортного и безопасного восстановления.',
      mainTitle: 'Заботливый уход, где бы вы ни были',
      mainDesc1: 'Восстановление не заканчивается, когда вы покидаете больницу. Наша профессиональная служба ухода обеспечивает качественную медицинскую помощь прямо в вашем номере.',
      mainDesc2: 'Нужна ли вам помощь с перевязками, капельницами, упражнениями или просто мониторинг показателей здоровья — наши медсёстры обеспечат внимательный уход.',
      features: {
        registered: { title: 'Дипломированные медсёстры', desc: 'Все наши медсёстры — дипломированные специалисты с опытом в реанимации, хирургии и домашнем уходе.' },
        location: { title: 'Уход у вас', desc: 'Визиты медсестёр в ваш отель, апартаменты или любое жильё.' },
        flexible: { title: 'Гибкий график', desc: 'Выбирайте почасовые визиты, дневной уход или круглосуточный уход.' },
        emergency: { title: 'Экстренная помощь', desc: 'Обучены действовать в экстренных ситуациях с прямой связью с вашей медицинской командой.' },
      },
      servicesTitle: 'Наши услуги ухода включают',
      servicesList: [
        'Мониторинг жизненных показателей (давление, температура, пульс, кислород)',
        'Введение и контроль лекарств',
        'Уход за ранами и смена повязок',
        'Капельницы и инъекции',
        'Уход за катетером',
        'Послеоперационный уход и наблюдение',
        'Контроль диабета и введение инсулина',
        'Помощь в обезболивании',
        'Помощь с передвижением и повседневными делами',
        'Контроль питания',
        'Координация с вашими врачами',
        'Первая помощь в экстренных ситуациях',
      ],
      packagesTitle: 'Варианты пакетов ухода',
      hourlyVisits: { title: 'Почасовые визиты', desc: 'Запланированные визиты для конкретных задач', features: ['Сеансы 1-4 часа', 'Идеально для перевязок', 'Помощь с лекарствами'] },
      dayCare: { title: 'Дневной уход', desc: '8-12 часов медицинской поддержки', features: ['Дневной мониторинг', 'Несколько задач ухода', 'Помощь с активностями'] },
      fullCare: { title: 'Уход 24/7', desc: 'Круглосуточный уход', features: ['Постоянный мониторинг', 'Ночной уход включён', 'Полная поддержка'] },
    },
    
    physiotherapist: {
      title: 'Физиотерапия',
      subtitle: 'Экспертные услуги физиотерапии для ускорения восстановления и возвращения подвижности.',
      mainTitle: 'Восстановить подвижность, вернуть силу',
      mainDesc1: 'Физиотерапия — важнейший компонент восстановления после многих процедур, особенно ортопедических операций и неврологического лечения.',
      mainDesc2: 'Нужны ли вам сеансы в номере или визиты в ближайший центр физиотерапии — мы организуем индивидуальные планы лечения совместно с вашим хирургом.',
      features: {
        certified: { title: 'Сертифицированные специалисты', desc: 'Лицензированные физиотерапевты с опытом послеоперационной реабилитации и спортивной медицины.' },
        personalized: { title: 'Индивидуальные программы', desc: 'Планы лечения, адаптированные к вашей операции, состоянию и целям восстановления.' },
        equipment: { title: 'Современное оборудование', desc: 'Доступ к передовому оборудованию и техникам физиотерапии.' },
        flexible: { title: 'Гибкие сеансы', desc: 'Визиты в номер, в клинику или гибридные варианты по вашему выбору.' },
      },
      specializationsTitle: 'Наши специализации физиотерапии',
      specializationsList: [
        'Реабилитация после замены коленного сустава',
        'Восстановление после замены тазобедренного сустава',
        'Реабилитация после операции на позвоночнике',
        'Терапия плеча и ротаторной манжеты',
        'Кардиореабилитация',
        'Неврологическая физиотерапия',
        'Восстановление после спортивных травм',
        'Реабилитация после инсульта',
        'Предоперационное укрепление',
        'Баланс и профилактика падений',
        'Терапия боли',
        'Упражнения на амплитуду движений',
      ],
      journeyTitle: 'Ваш путь физиотерапии',
      journeySteps: [
        { title: 'Первичная оценка', desc: 'Комплексная оценка вашего состояния, подвижности и целей совместно с медицинской командой.' },
        { title: 'Индивидуальный план', desc: 'Разработка персонализированного плана лечения с конкретными упражнениями и целями.' },
        { title: 'Регулярные сеансы', desc: 'Сеансы физиотерапии под руководством специалиста у вас или в ближайшем центре.' },
        { title: 'Отслеживание прогресса', desc: 'Регулярная оценка улучшений с корректировкой плана лечения.' },
        { title: 'Программа домашних упражнений', desc: 'Перед отъездом получите полное руководство по упражнениям для продолжения восстановления дома.' },
      ],
    },
    
    travelAccommodation: {
      title: 'Организация путешествия и проживания',
      subtitle: 'Полное планирование поездки и комфортное проживание рядом с больницей — всё организовано для вас.',
      mainTitle: 'Ваш комфорт — наш приоритет',
      mainDesc1: 'Планирование медицинской поездки включает больше, чем выбор больницы. От бронирования авиабилетов до поиска идеального жилья — мы заботимся о всей логистике.',
      mainDesc2: 'Предпочитаете ли вы бюджетный гостевой дом, комфортный отель или апартаменты для длительного пребывания — у нас есть партнёрства с жильём, понимающим потребности медицинских туристов.',
      features: {
        flights: { title: 'Помощь с авиабилетами', desc: 'Помощь в поиске лучших рейсов, оформлении визы и специальных запросов.' },
        hotels: { title: 'Подобранное жильё', desc: 'Отели и апартаменты возле крупных больниц, проверенные на комфорт и удобство.' },
        location: { title: 'Отличные локации', desc: 'Жильё в лёгкой доступности от больниц, аптек и необходимых услуг.' },
        quality: { title: 'Гарантия качества', desc: 'Все варианты проверены на чистоту, безопасность и удобство для медицинских туристов.' },
      },
      accommodationTypes: 'Варианты проживания',
      guesthouse: { title: 'Гостевые дома', desc: 'Доступно, чисто и комфортно', features: ['Базовые удобства', 'Рядом с больницами', 'Домашняя еда', 'Семейное обслуживание'] },
      hotels: { title: 'Отели (3-5 звёзд)', desc: 'Премиум комфорт и сервис', features: ['Обслуживание номеров 24/7', 'Консьерж', 'Ресторан и кафе', 'Ежедневная уборка'] },
      apartments: { title: 'Апартаменты', desc: 'Дом вдали от дома', features: ['Полная кухня', 'Жилая зона', 'Скидки на длительное пребывание', 'Для семей'] },
      arrangementsTitle: 'Что мы организуем для вас',
      arrangementsList: [
        'Помощь с бронированием авиабилетов',
        'Консультации по медицинской визе',
        'Подбор и бронирование жилья',
        'Координация трансфера из аэропорта',
        'Организация местной SIM-карты',
        'Консультации по обмену валюты',
        'Ориентация в местности',
        'Настройка экстренных контактов',
        'Организация продления пребывания',
        'Размещение сопровождающего',
        'Сообщение о диетических требованиях',
        'Карта расположения больницы',
      ],
      citiesTitle: 'Основные медицинские города назначения',
    },
    
    videoConsultations: {
      title: 'Видеоконсультации',
      subtitle: 'Свяжитесь с лучшими специалистами Индии из любой точки мира через защищённые видеозвонки.',
      mainTitle: 'Экспертное мнение, где бы вы ни были',
      mainDesc1: 'Не уверены, нужно ли ехать в Индию на лечение? Начните с видеоконсультации. Наша защищённая платформа телемедицины соединит вас с ведущими специалистами Индии.',
      mainDesc2: 'Видеоконсультации идеальны для первичной оценки, планирования лечения, второго мнения и послелечебного наблюдения.',
      features: {
        global: { title: 'Глобальная доступность', desc: 'Подключайтесь из любой страны, любого часового пояса. Мы планируем встречи в удобное для вас время.' },
        secure: { title: 'Соответствие HIPAA', desc: 'Сквозное шифрование видеозвонков обеспечивает конфиденциальность вашей медицинской информации.' },
        flexible: { title: 'Гибкое расписание', desc: 'Ранние утренние или поздние вечерние слоты для разных часовых поясов.' },
        easy: { title: 'Простота использования', desc: 'Простая платформа, работающая на телефоне, планшете или компьютере. Специальное ПО не требуется.' },
      },
      howItWorks: 'Как работает видеоконсультация',
      steps: [
        { title: 'Забронируйте встречу', desc: 'Отправьте запрос с медицинскими документами. Наша команда подберёт подходящего специалиста.' },
        { title: 'Изучение документов', desc: 'Специалист изучит ваши документы до звонка для максимальной эффективности консультации.' },
        { title: 'Видеоконсультация', desc: 'Присоединитесь к защищённому видеозвонку в назначенное время. Обсудите состояние, задайте вопросы и получите экспертный совет.' },
        { title: 'Письменное заключение', desc: 'Получите подробное резюме консультации с диагнозом, рекомендациями и следующими шагами.' },
        { title: 'Последующая поддержка', desc: 'Наша команда остаётся на связи, чтобы помочь понять рекомендации и спланировать лечение.' },
      ],
      consultationTypes: 'Типы видеоконсультаций',
      typesList: [
        'Первичная медицинская оценка',
        'Консультация для второго мнения',
        'Обсуждение плана лечения',
        'Предоперационная консультация',
        'Послелечебное наблюдение',
        'Обзор направления к специалисту',
        'Интерпретация медицинских отчётов',
        'Оценка стоимости лечения',
        'Оценка возможности операции',
        'Ведение хронических заболеваний',
      ],
      specialtiesTitle: 'Специальности для видеоконсультаций',
    },
  },
  
  // Treatments Page
  treatments: {
    heroTitle: 'Медицинское Лечение',
    heroTitleHighlight: 'Мирового Класса',
    heroSubtitle: 'Индия предлагает передовое медицинское лечение за малую часть стоимости. Изучите наш полный спектр специальностей и процедур.',
    jciAccredited: 'Больницы с Аккредитацией JCI',
    costSavings: '60-80% Экономии',
    expertSurgeons: 'Опытные Хирурги',
    filters: 'Фильтры',
    showing: 'Показано',
    treatmentsCount: 'лечений',
    commonProcedures: 'Распространённые Процедуры',
    learnMore: 'Подробнее',
    savingsCompared: 'экономия по сравнению с США',
  },
  
  // Doctors Page
  doctors: {
    heroTitle: 'Свяжитесь с',
    heroTitleHighlight: 'Лучшими Врачами Индии',
    heroSubtitle: 'Высококвалифицированные специалисты с международным образованием и многолетним опытом в своих областях.',
    filterDoctors: 'Фильтровать Врачей',
    hideFilters: 'Скрыть Фильтры',
    showFilters: 'Показать Фильтры',
    city: 'Город',
    allCities: 'Все Города',
    state: 'Штат',
    allStates: 'Все Штаты',
    specialization: 'Специализация',
    allSpecializations: 'Все Специальности',
    experience: 'Опыт',
    anyExperience: 'Любой Опыт',
    yearsPlus: 'лет+',
    showing: 'Показано',
    doctorsCount: 'врачей',
    yearsExperience: 'лет опыта',
    viewProfile: 'Посмотреть Профиль',
    requestAppointment: 'Записаться на Приём',
    noResults: 'Врачи по вашим критериям не найдены',
    tryAdjusting: 'Попробуйте изменить фильтры для большего количества результатов',
    clearFilters: 'Сбросить Фильтры',
  },
  
  // Hospitals Page
  hospitals: {
    heroTitle: 'Лучшие',
    heroTitleHighlight: 'Больницы Индии',
    heroSubtitle: 'Больницы с аккредитацией JCI, инфраструктурой мирового класса, передовыми технологиями и исключительным уходом за пациентами в 9 штатах.',
    hospitalsCount: 'Больницы',
    jciAccredited: 'Аккредитация JCI',
    expertTeams: 'Опытные Медицинские Команды',
    filters: 'Фильтры',
    showing: 'Показано',
    hospitalsCountLabel: 'больниц',
    bedCapacity: 'Количество Коек',
    viewHospital: 'Посмотреть Больницу',
    specialties: 'Специальности',
    accreditations: 'Аккредитации',
  },
  
  // Wellness Page
  wellness: {
    heroTitle: 'Комплексное Оздоровление и',
    heroTitleHighlight: 'Восстановление',
    heroSubtitle: 'Сочетайте медицинское лечение мирового класса с древними оздоровительными традициями Индии для полного исцеления тела, разума и духа.',
    ayurveda: 'Аюрведа',
    yoga: 'Йога и Медитация',
    naturopathy: 'Натуропатия',
    spa: 'Спа и Омоложение',
    whyChoose: 'Почему Выбрать Индию для Оздоровления',
    healingTraditions: 'Индия имеет 5000-летнюю традицию комплексного исцеления через Аюрведу, йогу и натуропатию.',
    integratedCare: 'Наши оздоровительные программы разработаны для дополнения вашего медицинского лечения и ускорения восстановления.',
  },
  
  // Medical Visa Page
  medicalVisa: {
    heroTitle: 'Помощь с',
    heroTitleHighlight: 'Медицинской Визой',
    heroSubtitle: 'Мы проведём вас через весь процесс получения медицинской визы, сделав вашу поездку за здоровьем в Индию гладкой и беспроблемной.',
    whatIs: 'Что Такое Медицинская Виза?',
    whatIsDesc: 'Медицинская виза (M-Visa) выдаётся иностранным гражданам, которые ищут медицинское лечение в Индии. Она позволяет многократный въезд и действительна до одного года.',
    eligibility: 'Право на Получение',
    eligibilityDesc: 'Пациенты, ищущие лечение в признанных индийских больницах',
    validity: 'Срок Действия',
    validityDesc: 'До 1 года или 3-кратной продолжительности лечения',
    entries: 'Въезды',
    entriesDesc: 'Тройной въезд, с возможностью продления',
    attendants: 'Сопровождающие',
    attendantsDesc: 'До 2 виз для медицинских сопровождающих (MX-Visa)',
    documentsRequired: 'Необходимые Документы',
    howWeHelp: 'Как Мы Помогаем',
  },
};

export default ru;
